import React, { Component, PropTypes } from 'react';
import { Paper, Styles } from 'material-ui';
import { ThemeStore } from 'stores';
import * as SvgIcons from 'components/Material/SvgIcons';
import Cover from 'components/Material/Cover';
import { FormattedMessage } from 'react-intl';

const { Colors, Spacing } = Styles;

const styles = {
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center'
  },
  item: {
    width: '100%',
    marginBottom: Spacing.desktopGutterMore,
    position: 'relative'
  },
  detail: {
    padding: Spacing.desktopGutter,
    boxSizing: 'border-box',
    height: 88,
    lineHeight: `${88 - 2 * Spacing.desktopGutter}px`
  },
  header: {
    fontSize: '24px',
    margin: 0,
    fontWeight: 100,
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden'
  },
  packIcon: {
    verticalAlign: 'middle'
  }
};

class CoursePackageList extends Component {
  static propTypes = {
    courses: PropTypes.array,
    canIEdit: PropTypes.bool,
    themeColor: PropTypes.string
  };

  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  getPackStyle(themeColor) {
    return {
      backgroundColor: ThemeStore.getColor(themeColor),
      position: 'absolute',
      top: 24,
      left: -24,
      lineHeight: '24px',
      padding: `${Spacing.desktopGutterMini / 4}px ${
        Spacing.desktopGutterMini
      }px`,
      color: Colors.fullWhite,
      fontWeight: 500
    };
  }

  render() {
    const { courses, canIEdit, themeColor } = this.props;
    const packStyle = this.getPackStyle(themeColor);

    return (
      <div style={styles.container}>
        {courses.map(course => {
          const { name, coverUrl } = course;
          return (
            <Paper style={styles.item} key={course.id}>
              <Cover
                backgroundColor={
                  (!canIEdit && ThemeStore.getColor(themeColor, 0.5)) ||
                  'rgba(0, 0, 0, 0.5)'
                }
                image={coverUrl}
              />
              <div style={styles.detail}>
                <div style={styles.header}>{name}</div>
              </div>
            </Paper>
          );
        })}
      </div>
    );
  }
}

export default CoursePackageList;



// WEBPACK FOOTER //
// ./src/js/components/Store/CoursePackageList.js